import React, {useState, useId, useContext} from 'react';
import classNames from 'classnames';
import {bem, jsClass} from '../../utils/bem';
import Button from './Button';
import Icon from './Icon';
import useClickOutside from '../../hooks/useClickOutside';
import useOnKeyPress from '../../hooks/useOnKeyPress';
import TranslationContext from '../../utils/I18n';

const block = bem('customSelect');

const CustomSelect = ({label, onChange = null, onClickReset = null, options = [], implicitCheck = false}) => {

	const [isOpen, setIsOpen] = useState(false);

	const t = useContext(TranslationContext);

	const [ref, setRef] = useState(null);
	useOnKeyPress('Escape', () => setIsOpen(false));
	useClickOutside(ref, () => isOpen && setIsOpen(false));

	const id = useId();
	return (
		<div ref={setRef} className={classNames(block({multi: true}), {[jsClass('toggled')]: isOpen, [jsClass('implicitCheck')]: implicitCheck})}>
			<Button onClick={() => setIsOpen(!isOpen)}
							icon={{
								name: 'chevron-large-down',
								width: 17,
								height: 10
							}}
							className={classNames({[jsClass('toggled')]: isOpen})}
							modifiers={{customSelectToggler: true}}
			>{label}</Button>
			<div className={block('optionsContainer')}>
				<div className={classNames(block('options'), {
					[jsClass('opened')]: isOpen,
					[jsClass('beforeOpened')]: isOpen,
					[jsClass('duringOpened')]: isOpen
				})}>
					<ul className={block('optionsItems')}>
						{options.map(option => {
							const optionId = `${id}-${option.value}`;
							return (
								<li key={option.value} className={block('option')}>
									<input id={optionId}
												 type="checkbox"
												 checked={option.selected}
												 disabled={option.disabled}
												 className={block('input', {checkbox: true, checked: option.selected})}
												 onChange={ev => onChange(option, ev)}/>
									<label className={block('label')} htmlFor={optionId}>
										<Icon className={block('inputIcon', {checked: true})} name="check" width={17} height={13}/>
										<span className={block('labelValue')}>{option.label}</span>
									</label>
								</li>
							);
						})}
					</ul>
					{onClickReset !== null && <Button modifiers={{customSelectReset: true}} onClick={onClickReset}>{t('customSelect.reset')}</Button>}
				</div>
			</div>
		</div>
	);
};

export default CustomSelect;
